import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/material'
import { Dropzone } from '~/components'
import { showToast } from '~/utils'
import { acceptedVideoTypes } from '../data'
import Alt from './Alt'
import Field from './Field'
import { useParagraphContext } from './hooks'
import Preview from './Preview'

const MAX_WEBM_BYTES = 600 * 1024
const MAX_MP4_BYTES = 5 * 1024 * 1024

const Anim = ({ alt }) => {
  const { t } = useTranslation()

  const { paragraph, uploadImage } = useParagraphContext(Anim.name)

  return (
    <Stack spacing={0.5}>
      <Field
        name="media"
        render={() => (
          <Dropzone
            accept={acceptedVideoTypes}
            maxFileSize={MAX_MP4_BYTES}
            multiple={false}
            sx={{
              minHeight: '80px',
              ...(paragraph.media
                ? {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: 0,
                    p: 0,
                    '& img': {
                      objectFit: 'contain',
                      width: '100%',
                      height: '100%',
                    },
                  }
                : { px: 1.5, py: 1 }),
              overflow: 'clip',
            }}
            onDrop={async (files) => {
              const file = files[0]
              if (file.type === 'video/webm' && file.size > MAX_WEBM_BYTES) {
                showToast(
                  t('upload.too-big', {
                    file: file.name,
                    size: `${(MAX_WEBM_BYTES / 1024).toFixed(1)}KB`,
                  }),
                  { variant: 'error' }
                )
                return
              }
              await uploadImage('anim', file)
            }}
          >
            {paragraph.media ? (
              <video
                src={paragraph.media}
                autoPlay
                controls
                muted
                loop
                style={{ width: '100%', height: '100%' }}
              />
            ) : undefined}
          </Dropzone>
        )}
      />
      <Alt
        {...alt}
        maxLength={alt?.maxLength ?? 255}
        multiline={alt?.multiline ?? true}
        placeholder={alt?.placeholder ?? t('paragraph.caption')}
        property="caption"
      />
      <Preview />
    </Stack>
  )
}

Anim.propTypes = {
  alt: Alt.propTypes,
}

export default Anim
